<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-card elevation="0" outlined class="mt-5">
        <v-sheet class="pa-4 d-md-flex">
          <v-sheet class="flex-sm-column">
            <p class="text-h4 ma-0">Active Users</p>
          </v-sheet>

          <v-spacer></v-spacer>

          <v-sheet class="flex-sm-column">
            <v-row class="flex">
              <v-col cols="12" md="12">
                <v-text-field
                  dense
                  v-model="searchTerms"
                  @keyup.enter="search"
                  @click:clear="clearSearch"
                  rounded
                  @click:append="search"
                  placeholder="Search User"
                  append-icon="mdi-magnify"
                  outlined
                  clearable
                  hide-details
                  label="Search"
                />
              </v-col>
            </v-row>
          </v-sheet>
        </v-sheet>
      </v-card>

      <v-card elevation="0" class="mt-5">
        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="userList"
            :items-per-page="pagination.pageSize"
            :server-items-length="pagination.totalSize"
            :page="pagination.current"
            :disable-pagination="!userList || userList.length < 1"
            :hide-default-header="!userList || userList.length < 1"
            :hide-default-footer="!userList || userList.length < 1"
            :disable-sort="true"
            item-key="id"
            class="elevation-1"
            @update:options="pageChanged"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon color="red" class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>

    <confirmation-dialog ref="confirm" />

    <v-row justify="center">
      <v-dialog v-model="userDialog" persistent max-width="800px">
        <v-card elevation="0">
          <v-card-text elevation="0">
            <user-form
              :key="userId"
              :id="userId"
              :isModal="true"
              @closeUserDialog="closeUserDialog"
            ></user-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="viewUserDialog" persistent max-width="600px">
        <v-card elevation="0">
          <v-card-text elevation="0" class="pa-0">
            <view-user
              v-if="userId"
              :key="userId"
              :userId="userId"
              :isModal="true"
              @closeUserDialog="closeUserDialog"
              @editUserDialog="editFromView"
            ></view-user>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  getActiveUsers,
  removeActiveUser,
} from "@/services/accountServices.js";

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100,
      },
      userList: [],
      showParentPage: true,
      searchTerms: "",
      headers: [
        {
          text: "Id",
          value: "accountId",
          align: "start",
          sortable: true,
        },
        {
          text: "User Name",
          value: "username",
          align: "start",
          sortable: true,
        },
        {
          text: "Issued at",
          value: "issuedAt",
          align: "start",
          sortable: true,
        },
        {
          text: "Expiration",
          value: "expiration",
          align: "start",
          sortable: true,
        },
        {
          text: "User Agent",
          value: "userAgent",
          align: "start",
          sortable: false,
        },
        {
          text: "ipAddress",
          value: "ipAddress",
          align: "start",
          sortable: false,
        },

        { text: "Actions", value: "actions", align: "end", sortable: false },
      ],
      sort: {
        key: null,
      },
    };
  },

  computed: {
    // ...mapGetters("user", ["userProcessed", "getUsers"])
  },

  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),

    search() {
      this.getResources();
    },

    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    },

    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },

    getResources() {
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        searchTerms: this.searchTerms,
      };
      getActiveUsers(params)
        .then((response) => {
          if (response) {
            this.userList = response.data.map((user) => {
              return {
                ...user,
                issuedAt: new Date(user.issuedAt).toLocaleString(),
                expiration: new Date(user.expiration).toLocaleString(),
                userAgent: user.userAgent,
                ipAddress: user.ipAddress
              };
            });
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },

    showParent(show) {
      this.showParentPage = show;
    },

    edit() {
      //   this.userId = item.id;
      //   this.userDialog = true;
    },

    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this user?",
      );
      if (confirm) {
        removeActiveUser(item.username)
          .then(() => {
            this.addSuccessMessage("user was deleted with successfull!");
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },

    beforeRouteUpdate(to, from, next) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.showParentPage = toDepth < fromDepth;
      if (this.showParentPage) {
        this.getResources();
      }
      next();
    },
  },
};
</script>
